<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="cnpj">CNJ:</label>
                        <input id="cnpj" type="text" readonly="readonly" :value="cnj"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <hr class="mt-4"/>

        <p><b>Memória de Cálculo</b></p>

        <b-row>
            <b-col md="8">
                <ul class="memoria">
                    <li>
                        <span class="mem-descricao">- Valor dos Honorários</span>
                        <span class="mem-valor pull-right">R$ {{ valorHonorarios() | currency }}</span>
                    </li>
                    <li v-if="valorHonorariosCorrigido() != null">
                        <span class="mem-descricao">- Valor Corrigido dos Honorários</span>
                        <span class="mem-valor">R$ {{ valorHonorariosCorrigido() | currency }}</span>
                    </li>
                    <li v-if="valorPagamentosAnteriores() != null">
                        <span class="mem-descricao">- Pagamento(s) anterior(es) deduzido(s)</span>
                        <span class="mem-valor">R$ {{ valorPagamentosAnteriores() | currency }}</span>
                    </li>
                    <li v-if="requisicao.valorJuros != null">
                        <span class="mem-descricao">- Juros de Mora</span>
                        <span class="mem-valor">R$ {{ requisicao.valorJuros | currency }}</span>
                    </li>
                    <li v-if="multa() != null || honorarios() != null">
                        <span class="mem-total">Sub Total</span>
                        <span class="mem-valor">R$ {{ subTotal() | currency }}</span>
                    </li>
                    <li v-if="multa() != null">
                        <span class="mem-descricao">- Multa de 10% do art.523/CPC</span>
                        <span class="mem-valor">R$ {{ multa() | currency }}</span>
                    </li>
                    <li v-if="honorarios() != null">
                        <span class="mem-descricao">- Honorários de 10% do art.523/CPC</span>
                        <span class="mem-valor">R$ {{ honorarios() | currency }}</span>
                    </li>
                    <li>
                        <span class="mem-total">TOTAL</span>
                        <span :class="'mem-valor' + (total() <= 0 ? ' is-invalid' : '')">R$ {{ total() | currency }}</span>
                        <div v-if="total() <= 0" class="invalid-message">Não é permitida a emissão de Requisicação de valor zero ou negativo!</div>
                    </li>
                </ul>
            </b-col>
        </b-row>

        <div v-if="devedores.length > 0">
            <p><b>Divisão em Cotas</b></p>

            <b-row>
                <b-col md="8">
                    <ul class="memoria">
                        <li v-for="devedorLista in devedores">
                            <span class="mem-descricao">- {{ devedorLista.nome }}</span>
                            <span class="mem-valor pull-right">R$ {{ totalCota(devedorLista.cota) | currency }} ({{ devedorLista.cota }}%)</span>
                        </li>
                        <li>
                            <span class="mem-descricao">- {{ devedor.nome }}</span>
                            <span class="mem-valor pull-right">R$ {{ totalCota(devedor.cota) | currency }} ({{ devedor.cota }}%)</span>
                        </li>
                    </ul>
                </b-col>
            </b-row>
        </div>

        <b-row style="text-align: right; margin-top: -30px;">
            <b-col md="12">
                <b-button variant="outline-secondary" @click="exportarMemoria">
                    <i class="fas fa-print"></i> Imprimir Memória de Cálculo
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="12">
                <p><b>Opções Complementares</b></p>
                <b-form-group label label-for="emitirTermo" v-if="requisicao.tipoPagamento == 1">
                    <b-form-checkbox v-model="requisicao.emitirTermo" id="emitirTermo" name="check-button">
                        Emitir <b>Termo de Parcelamento de Honorários</b>
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label label-for="enviarDocumentacao">
                    <b-form-checkbox v-model="requisicao.enviarDocumentacao" id="enviarDocumentacao" name="check-button">
                        Enviar documentação gerada (Termo de parcelamento, memória de cálculo e boleto) ao <b>E-mail</b>
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
            <b-col md="6" style="margin-top: -8px;">
                <b-col>
                    <b-form-input v-model="requisicao.email" type="text" id="email" maxlength="100"
                                      @keyup="requisicao.email = removeSpecialCharactersGeralVirgula(requisicao.email)"/>
                </b-col>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="4">
                <b-form-group label="Informe o Setor responsável pela Requisição:"
                              label-for="valorindica"
                              class="text-label required">
                    <b-form-select v-model="requisicao.setor" :class="!validations.setor.valid ? 'invalid-select' : ''">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                            v-for="setor in dados.setoresFiltrados"
                            :key="setor.codSetor"
                            :value="setor">
                            {{ setor.nome ? setor.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                    <div v-if="!validations.setor.valid" class="invalid-message">O campo Setor é obrigatório.</div>
                </b-form-group>
            </b-col>
            <b-col md="8">
                <b-col>
                    <label for="carregarArq" :class="(!validations.arquivo.valid ? 'is-invalid' : '')">Anexar arquivo à Requisição (ex.: decisão judicial, garantia etc.) (opcional):</label>
                    <b-form-group id="input-group-1" label="" label-for="parcelamento">
                        <b-form-file id="carregarArq" v-model="arquivos" @input="realizarUpload"
                                     :class="!validations.arquivo.valid ? 'is-invalid' : ''"
                                     placeholder="Selecionar um arquivo"
                                     accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                        <div v-if="!validations.arquivo.valid" class="invalid-message">Tamanho do arquivo ultrapassa o limite definido em 50mb.</div>
                    </b-form-group>
                </b-col>
            </b-col>
        </b-row>

        <b-row v-for="arquivo in requisicao.arquivos">
            <b-col md="4"></b-col>
            <b-col md="6" class="mt-1">
                <a class="link" style="margin-left: 30px;" @click="obterAnexo(arquivo)">
                    {{ arquivo.nomeArquivo }}
                </a>
                <b-button class="ml-2"
                          variant="outline-warning"
                          @click="excluirArquivo(arquivo)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="mt-1 align-items-center">
            <div class="px-3">
                <label class="text-bold">Observações:</label>
            </div>
        </b-row>
        <b-row class="mb-0">
            <b-col>
                <b-form-textarea
                    id="observacoes"
                    v-model="requisicao.observacoes"
                    size="500"
                    placeholder=""
                    max-rows="10"
                ></b-form-textarea>
            </b-col>
        </b-row>

        <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert alert-secondary mb-0 alert-info mt-2" v-if="acessoLimitado">
            <b-form-group label label-for="submeterProcurador">
                <b-form-checkbox v-model="submeterProcurador" id="submeterProcurador" @input="alterarSubmeterProcurador" name="check-button">
                    Submeter a Minuta de Requisição a um Procurador
                </b-form-checkbox>
            </b-form-group>

            <div v-if="submeterProcurador">
                <p><b>Obs.:</b> Caso a Requisição em processo de criação necessite de aprovação por algum Procurador do Estado, selecione no quadro abaixo um Procurador como responsável pela Requisição e, em seguida, clique sobre o botão Enviar. Essa ação submeterá a finalização da Requisição ao Procurador selecionado. Caso não seja necessária a aprovação por nenhum Procurador, basta finalizar a criação da Requisição pelo botão Concluir Geração.</p>

                <b-row>
                    <b-col md="4">
                        <b-form-group
                                label="Indique o procurador:"
                                label-for="valorindica"
                                class="text-label required">
                            <b-form-select v-model="requisicao.procurador" :class="!validations.procurador.valid ? 'is-invalid mb-3' : 'mb-3'">
                                <template v-slot:first>
                                    <option :value="null">Selecionar</option>
                                </template>
                                <option
                                        v-for="tc in dados.procuradores"
                                        :key="tc.codProcurador"
                                        :value="tc.codProcurador">
                                    {{ tc.nome }}
                                </option>
                            </b-form-select>
                            <div v-if="!validations.procurador.valid" class="invalid-message">Indique o Procurador.</div>
                        </b-form-group>
                    </b-col>
                    <b-col md="2" class="mt-4">
                        <b-button variant="primary" @click="salvar">
                            <i class="far fa-paper-plane"></i> Enviar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <CompLoading ref="loading"/>
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loading"
                type="HONORARIOS_ACAO_JUDICIAL"
                @salvarDevedor="salvarDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";

    export default {
        props: ['cnj','requisicao','devedores', 'listaContribuintes', 'devedor','acessoLimitado','submeterProcurador'],
        mixins: [ formatarMixins ],
        components: {CompLoading, ModalAlterarDevedor},
        data() {
            return {
                urlApi: null,
                token: null,
                arquivos: [],
                arquivosTemp: [],
                dados: {
                    setores: [],
                    setoresFiltrados: [],
                    procuradores: [],
                },
                validations: {
                    arquivo: { valid: true },
                    procurador: { valid: true },
                    setor: { valid: true },
                    existeEmailDevedor: { valid: true }
                },
            }
        },
        methods: {
            valorHonorarios() {
                if(this.requisicao.honorarioFixo) {
                    if(this.requisicao.valorFixo != null) {
                        return this.requisicao.valorFixo.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                    }
                } else if(!this.requisicao.percentual) {
                    if(this.requisicao.valorBaseCalculo != null && this.requisicao.valorIndice != null) {
                        let valorBaseCalculoTemp = parseFloat(this.requisicao.valorBaseCalculo.toString().replace(/[^1234567890,]/g, "").replace(",", "."));
                        let valorIndiceTemp = this.requisicao.valorIndice.toString().replace(/[^1234567890,]/g, "").replace(",", ".");
                        return (valorBaseCalculoTemp * valorIndiceTemp) / 100;
                    }
                } else {
                    return this.requisicao.valorHonorariosArtigo;
                }
            },
            valorHonorariosCorrigido() {
                if(this.requisicao.valorCorrecao != null && parseFloat(this.requisicao.valorCorrecao) != 0) {
                    return parseFloat(this.valorHonorarios()) + parseFloat(this.requisicao.valorCorrecao);
                }

                return null;
            },
            valorPagamentosAnteriores() {
                if(this.requisicao.deduzirPagamentos && this.requisicao.valoresAnteriores != null && parseFloat(this.requisicao.valoresAnteriores) > 0) {
                    let valor = parseFloat(this.requisicao.valoresAnteriores);
                    return valor;
                }

                return null;
            },
            subTotal() {
                let valor =
                    (this.valorHonorariosCorrigido() != null ? this.valorHonorariosCorrigido() : this.valorHonorarios())
                    - (this.valorPagamentosAnteriores() != null ? this.valorPagamentosAnteriores() : 0)
                    + (this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0);

                return valor;
            },
            multa() {
                if(this.requisicao.multaArtCpc) {
                    let valor = parseFloat((this.valorHonorariosCorrigido() != null ? this.valorHonorariosCorrigido() : this.valorHonorarios()))
                        + parseFloat((this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0))
                        - parseFloat((this.valorPagamentosAnteriores() != null ? this.valorPagamentosAnteriores() : 0));
                    return valor * 0.1;
                }

                return null;
            },
            honorarios() {
                if(this.requisicao.honorariosArtCpc) {
                    let valor = parseFloat((this.valorHonorariosCorrigido() != null ? this.valorHonorariosCorrigido() : this.valorHonorarios()))
                        + parseFloat((this.requisicao.valorJuros != null ? this.requisicao.valorJuros : 0))
                        - parseFloat((this.valorPagamentosAnteriores() != null ? this.valorPagamentosAnteriores() : 0));
                    return valor * 0.1;
                }

                return null;
            },
            total() {
                let valor = this.subTotal()
                    + (this.multa() != null ? this.multa() : 0)
                    + (this.honorarios() != null ? this.honorarios() : 0);

                return valor.toFixed(2);
            },
            totalCota(cota) {
                let valor = this.total();
                if(cota != null) {
                    valor = (valor * cota.toString().replace(",", ".")) / 100.0;
                }

                return valor;
            },
            realizarUpload(arquivo) {
                this.validations.arquivo.valid = true;
                if(arquivo != null) {
                    this.$store.commit("setMessages", {});
                    let arquivoConvertido = null
                    if ((arquivo.size / 1024) / 1024 > 50.0) {
                        this.validations.arquivo.valid = false;
                    } else {
                        var reader = new FileReader()
                        reader.onload = function (e) {
                            arquivoConvertido = {
                                nomeArquivo: arquivo.name,
                                base64: e.target.result
                            }
                        }
                        reader.readAsDataURL(arquivo)
                        reader.onloadend = () => {
                            this.$emit('executeUpload', arquivoConvertido);
                            this.arquivos = [];
                            this.arquivosTemp.push(arquivoConvertido);
                        }
                    }
                }
            },
            excluirArquivo(arquivo) {
                const index = this.arquivosTemp.indexOf(arquivo);
                this.arquivosTemp.splice(index, 1);
                this.$emit('excluirArquivo', arquivo);
            },
            exportarMemoria() {
                this.$emit('exportarMemoria');
            },
            salvar() {
                this.$emit('salvar', true);
            },
            alterarSubmeterProcurador(valorCheckbox) {
                this.$emit('alterarSubmeterProcurador', valorCheckbox);
            },
            atualizarSetor() {
                if(this.requisicao.setor != null && this.requisicao.setor.codSetor != null) {
                    for(var i = 0; i < this.dados.setores.length; i++) {
                        if(this.requisicao.setor.codSetor == this.dados.setores[i].codSetor) {
                            this.requisicao.setor = this.dados.setores[i];
                        }
                    }
                }
            },
            async listarSetores() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarSetores`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.setores = response.data
                    this.dados.setoresFiltrados = response.data
                })
            },
            async listarProcuradores() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarProcuradores`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.procuradores = response.data
                })
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
            abrirModalDevedor(devedor) {
                if(devedor.codDevedor != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(devedor.codDevedor);
                }
            },
            salvarDevedor(devedorSalvo) {
                if(this.listaContribuintes.length > 0) {
                    for(var i = 0; i < this.listaContribuintes.length; i++) {
                        if(this.listaContribuintes[i].codDevedor == devedorSalvo.codContribuinte) {
                            this.listaContribuintes[i].email = devedorSalvo.email
                            this.listaContribuintes[i].emailAlternativo1 = devedorSalvo.emailAlternativo1
                            this.listaContribuintes[i].emailAlternativo2 = devedorSalvo.emailAlternativo2
                        }
                    }
                }
            },
            adicionarEmailDevedor(devedor, emails) {
                if(devedor.email != null && devedor.email != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.email;
                }
                if(devedor.emailAlternativo1 != null && devedor.emailAlternativo1 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo1;
                }
                if(devedor.emailAlternativo2 != null && devedor.emailAlternativo2 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo2;
                }
                return emails;
            },
            validarProcurador(valid) {
                this.validations.procurador.valid = valid;
            },
            validarSetor(valid) {
                this.validations.setor.valid = valid;
            },
            validarEmailDevedor() {

                let valid = true;
                if (!this.requisicao.pagamento.aVista) {

                    let possuiEmail = false;
                    this.listaContribuintes.forEach(contrib => {
                        if(contrib.email || contrib.emailAlternativo1 || contrib.emailAlternativo2) {
                            possuiEmail = true;
                        }
                    });

                    // verificar os emails da lista
                    if (!possuiEmail) {
                        this.abrirModalDevedor(this.listaContribuintes[0])
                        valid = false;
                    }
                }

                this.validations.existeEmailDevedor.valid = valid;
                return valid;
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarSetores();
            this.listarProcuradores();
        }
    }
</script>

<style scoped>
    .memoria {
        list-style: none;
        width: 50%;
    }

    .mem-descricao {
        text-align: right;
    }

    .mem-valor {
        float: right;
    }

    .mem-total {
        text-align: right;
        font-weight: 700;
    }
</style>